import { PageHeader } from "@sylviq/ui-react-web/components/ui/page-header";
import { ContractorTab } from "@/features/tax/ContractorTab";

export function ContractorPaymentsPage() {
  return (
    <div className="grid gap-6">
      <PageHeader
        title="Contractor payments"
        description="Supplier payment totals for the year — the numbers behind a 1099 filing, which happens elsewhere."
      />
      <ContractorTab />
    </div>
  );
}
